import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import facebook from '../../assets/icons/facebook.svg';
import youtube from '../../assets/icons/youtube.svg';
import instagram from '../../assets/icons/instagram.svg';

const footer = (props) => {
    return(
        <div className='footer'>
            <Container>
                <Row>
                    <Col xs='12' md='6'>
                        <ul className='social-media-footer'>
                            <li><a href="https://www.facebook.com/ungdomssamfundet" target='blank'><img src={facebook} alt='Følg oss på Facebook'/></a></li>
                            <li><a href="https://www.youtube.com/channel/UCj0_YY8DoBmQyG6dfQLbPaw" target='blank'><img src={youtube} alt='Følg oss på YouTube' /></a></li>
                            <li><a href="/" target='blank'><img src={instagram} alt='Følg oss på Instagram' /></a></li>
                        </ul>
                    </Col>
                    <Col xs='12' md='6'>
                        <p>Copyright &copy; {new Date().getFullYear()} Extra Giverglede Halden - Alle rettigheter reservert. </p>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js